import React, { createContext, useContext, useEffect, useState } from 'react';
import { settingsService } from '../api/services';

const SettingsContext = createContext();

const normalizeSettings = (raw) => ({
  site_title: raw?.site_title || raw?.site_name || 'Tech Forum',
  header_title: raw?.header_title || raw?.site_name || 'Tech Forum',
  home_title: raw?.home_title || '技術交流平台',
  home_subtitle: raw?.home_subtitle || '分享知識，解決問題，一起成長',
  ...raw,
});

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(normalizeSettings({}));

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await settingsService.getAll();
        setSettings(normalizeSettings(res.data));
      } catch (err) {
        console.error('Load settings error:', err);
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    document.title = settings.site_title || 'Tech Forum';
  }, [settings.site_title]);

  const updateSetting = async (key, value) => {
    await settingsService.update(key, value);
    // 設定屬於跨元件全域狀態，正式 D1 寫入後重新讀取一次，避免樂觀更新與遠端持久化結果不一致。
    const refreshed = await settingsService.getAll();
    setSettings(normalizeSettings(refreshed.data));
    return refreshed;
  };

  return (
    <SettingsContext.Provider value={{ settings, updateSetting }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) throw new Error('useSettings must be used within SettingsProvider');
  return context;
};
